<div class="input-group mb-3" [class.wms-pending]="showWmsWarning()">
	<input
		[name]="'input' + name"
		[type]="masked ? 'password' : 'text'"
		class="form-control"
		[ngModel]="model"
		[ngClass]="classes()"
		readonly
		inert
	/>
	<div *ngIf="unit" class="input-group-append">
		<span class="input-group-text unit">{{unit}}</span>
	</div>
	<span *ngIf="showWmsWarning()" class="wms-indicator" title="Wird online automatisch ermittelt">
		<i class="bi bi-cloud-slash"></i>
	</span>
</div>
